<div class="w-100">
    
            <div class="input-group m-0 w-100" id="adv-search">
                <input  type="text" class="form-control" [placeholder]= placeholder 
                [(ngModel)]="searchValue" (input)="onSearchChange($event.target.value)"/>
               
            </div>
       
    </div>